import React from "react";
import { FaTrash, FaPlus, FaMinus } from "react-icons/fa";
import { useCarrito } from "./ContextoCarrito";
import Swal from "sweetalert2";

const Carrito = () => {
  const {
    carritoItems,
    loadingCarrito,
    actualizarCantidad,
    eliminarDelCarrito,
    total,
  } = useCarrito();

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const WHATSAPP_NUMERO = "59899075944";

  const aumentarCantidad = async (item) => {
    const stock = item.producto?.stock ?? 999999;
    if (item.cantidad < stock) {
      await actualizarCantidad(item.id, item.cantidad + 1);
    }
  };

  const disminuirCantidad = async (item) => {
    const nuevaCantidad = item.cantidad - 1;
    if (nuevaCantidad <= 0) {
      await eliminarDelCarrito(item.id);
    } else {
      await actualizarCantidad(item.id, nuevaCantidad);
    }
  };

  const finalizarCompraWhatsApp = () => {
    if (carritoItems.length === 0) return;

    const lineasProductos = carritoItems
      .map((item, index) => {
        const nombre = item.producto?.nombre || "Producto";
        const subtotal = item.precio_unitario * item.cantidad;
        return `${index + 1}. ${nombre}
- Cantidad: ${item.cantidad}
- Precio unitario: $ ${item.precio_unitario}
- Subtotal: $ ${subtotal}`;
      })
      .join("\n\n");

    const mensaje = `Hola, quiero realizar el siguiente pedido:

${lineasProductos}

Total del pedido: $ ${total}

Quedo atento/a. Gracias.`;

    const url = `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(
      mensaje
    )}`;

    window.open(url, "_blank");
  };

  const mostrarMercadoPagoEnProceso = () => {
    Swal.fire({
      icon: "info",
      title: "Mercado Pago en proceso",
      text: "Estamos preparando esta forma de pago. Por ahora podes finalizar la compra por WhatsApp.",
      confirmButtonColor: "#111",
    });
  };

  if (loadingCarrito) {
    return (
      <section className="min-h-screen flex justify-center items-center px-4" style={{ backgroundColor: "#f5f1ed" }}>
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-gray-900 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-xs uppercase tracking-widest text-gray-400">Cargando carrito...</p>
        </div>
      </section>
    );
  }

  if (carritoItems.length === 0) {
    return (
      <section className="min-h-screen flex justify-center items-center px-4" style={{ backgroundColor: "#f5f1ed" }}>
        <div className="bg-white p-6 sm:p-12 text-center max-w-xl w-full border border-gray-300">
          <h2 className="text-xl sm:text-2xl font-light text-gray-900 mb-4 uppercase tracking-wider">
            Tu carrito está vacío
          </h2>
          <p className="text-gray-500 text-sm">
            Agregá productos para comenzar
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="min-h-screen p-4 md:p-8" style={{ backgroundColor: "#f5f1ed" }}>
      <div className="max-w-7xl mx-auto bg-white p-4 md:p-8 border border-gray-300">
        <h2 className="text-2xl md:text-4xl font-light mb-6 md:mb-8 text-gray-900 uppercase tracking-wider">
          CARRITO DE COMPRAS
        </h2>

        <div className="hidden md:grid grid-cols-12 gap-4 border-b border-gray-300 pb-4 mb-4 text-xs font-semibold text-gray-600 uppercase tracking-widest">
          <div className="col-span-4">Producto</div>
          <div className="col-span-2 text-center">Precio</div>
          <div className="col-span-2 text-center">Cantidad</div>
          <div className="col-span-1 text-center">Stock</div>
          <div className="col-span-2 text-center">Subtotal</div>
          <div className="col-span-1 text-center">Acción</div>
        </div>

        <div className="space-y-4">
          {carritoItems.map((item) => {
            const producto = item.producto || {};
            const imageUrl = producto.imagen_url
              ? `${BASE_URL}${producto.imagen_url}`
              : "https://via.placeholder.com/120";

            return (
              <div
                key={item.id}
                className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center border border-gray-200 p-4 hover:bg-gray-50 transition"
              >
                <div className="md:col-span-4 flex items-center gap-4 min-w-0">
                  <img
                    src={imageUrl}
                    alt={producto.nombre}
                    className="w-20 h-20 object-cover border border-gray-200 flex-shrink-0"
                  />

                  <div>
                    <h3 className="font-semibold text-gray-900 break-words">
                      {producto.nombre}
                    </h3>
                    <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">
                      Producto
                    </p>
                  </div>
                </div>

                <div className="md:col-span-2 text-left md:text-center">
                  <span className="md:hidden font-semibold text-gray-500 mr-2">
                    Precio:
                  </span>
                  <span className="font-semibold text-gray-800">
                    $ {item.precio_unitario}
                  </span>
                </div>

                <div className="md:col-span-2">
                  <div className="flex items-center justify-start md:justify-center gap-3">
                    <button
                      onClick={() => disminuirCantidad(item)}
                      className="w-8 h-8 flex items-center justify-center border border-gray-300 hover:bg-gray-100 transition text-gray-600"
                    >
                      <FaMinus size={12} />
                    </button>

                    <span className="font-semibold text-gray-900 min-w-[32px] text-center text-sm">
                      {item.cantidad}
                    </span>

                    <button
                      onClick={() => aumentarCantidad(item)}
                      className="w-8 h-8 flex items-center justify-center border border-gray-300 hover:bg-gray-100 transition text-gray-600"
                    >
                      <FaPlus size={12} />
                    </button>
                  </div>
                </div>

                <div className="md:col-span-1 text-left md:text-center">
                  <span className="md:hidden font-semibold text-gray-500 mr-2">
                    Stock:
                  </span>
                  <span className="font-semibold text-gray-700">
                    {producto.stock ?? "-"}
                  </span>
                </div>

                <div className="md:col-span-2 text-left md:text-center">
                  <span className="md:hidden font-semibold text-gray-500 mr-2">
                    Subtotal:
                  </span>
                  <span className="font-extrabold text-gray-900">
                    $ {item.precio_unitario * item.cantidad}
                  </span>
                </div>

                <div className="md:col-span-1 flex justify-start md:justify-center">
                  <button
                    onClick={() => eliminarDelCarrito(item.id)}
                    className="text-gray-600 hover:text-gray-900 text-lg"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 md:mt-12 flex justify-end">
          <div className="bg-white border border-gray-300 p-5 md:p-8 w-full max-w-sm text-right">
            <p className="text-sm font-light text-gray-600 uppercase tracking-wider mb-2">Total</p>
            <p className="text-3xl font-semibold text-gray-900 mb-6">
              $ {total}
            </p>

            <button
              onClick={finalizarCompraWhatsApp}
              className="mt-6 w-full bg-black text-white px-6 py-3 font-bold text-xs uppercase tracking-wider hover:bg-gray-900 transition"
            >
              Finalizar por WhatsApp
            </button>

            <button
              onClick={mostrarMercadoPagoEnProceso}
              className="mt-3 w-full bg-stone-700 text-white px-6 py-3 font-bold text-xs uppercase tracking-wider hover:bg-stone-800 transition disabled:opacity-60 disabled:cursor-not-allowed"
            >
              Pagar con Mercado Pago
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Carrito;
